import { Component, Input } from '@angular/core';
import { ContactDataDto } from '@bo-client/shared/models/contactDataDto';
import { RequestModel } from '@bo-client/shared/models/request.model';
import { InstallerPassModel } from '@bo-client/shared/models/installerPassDto';

@Component({
  selector: 'app-show-create-update-data',
  templateUrl: './show-create-update-data.component.html',
  styleUrls: ['./show-create-update-data.component.scss']
})
export class ShowCreateUpdateDataComponent {
  @Input() createUpdateEntity: RequestModel | InstallerPassModel;
  @Input() createdByCustomer: ContactDataDto;

  constructor() {
    this.createUpdateEntity = null;
    this.createdByCustomer = null;
  }
}
